import React, { forwardRef } from 'react'
import * as UIcons from '@iconscout/react-unicons'
import ClickAwayComponent from 'components/ClickAwayComponent'

export default function FilterPill({ label, active, options, onSelect }) {
  return (
    <ClickAwayComponent
      Component={forwardRef(({ handleClick, open }, ref) => (
        <div className="relative" ref={ref}>
          <button
            type="button"
            onClick={handleClick}
            className="flex items-center gap-2 bg-background rounded-full h-9 px-3.5 text-sm font-medium text-dark-blue whitespace-nowrap"
          >
            {active ?? label}
            {open ? <UIcons.UilAngleUp size={16} className="text-secondary" /> : <UIcons.UilAngleDown size={16} className="text-secondary" />}
          </button>

          {
            open && (
              <div className="absolute left-0 top-11 z-20 w-56 bg-white border border-border-lines rounded-xl shadow-lg py-2">
                <ul className="max-h-60 overflow-y-auto">
                  {
                    options.map((option) => (
                      <li key={option}>
                        <button
                          type="button"
                          onClick={() => { onSelect(option); handleClick() }}
                          className="w-full text-left px-4 py-2 text-sm text-dark-blue hover:bg-background"
                        >
                          {option}
                        </button>
                      </li>
                    ))
                  }
                </ul>
              </div>
            )
          }
        </div>
      ))}
    />
  )
}
